/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface IDosageGuideline {
  id?: string;
  name?: string | null;
  description?: string | null;
  dosageValue?: string | null;
  dosageUnit?: string | null;
  recommendedDosage?: string | null;
  administrationRoute?: string | null;
  specialInstructions?: string | null;
  asNeeded?: boolean | null;
  asNeededCondition?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
}

export const defaultValue: Readonly<IDosageGuideline> = {
  asNeeded: false,
  active: false,
};
